import { esCrafterHtml, esCrafterXb } from '../../../common/EsCrafter';

/* A headed section of formatted text, as EsLegal's notices: es-<slug>-<key>-heading over
   es-<slug>-<key>-notice. The body is sanitized (esCrafterHtml) and {year} filled. */
export default function EsBlockRichText( { slug, block, item } ) {
    const aId = `es-${ slug }-${ block.key_s }`;

    return (
        <>
            { block.heading_s && (
                <h4 data-testid={ `${ aId }-heading` } className="mb-3 text-lg font-bold text-heading" { ...esCrafterXb( item, block, 'heading_s' ) }>
                    { block.heading_s }
                </h4>
            ) }
            <div data-testid={ `${ aId }-notice` } className="esCrafterRichText mb-10 text-base leading-8"
                 { ...esCrafterXb( item, block, 'body_html' ) }
                 // nosemgrep: react-dangerouslysetinnerhtml -- esCrafterHtml rebuilds from a tag allowlist; href only http:, https:, mailto:, # or a leading / (// included)
                 dangerouslySetInnerHTML={ { __html: esCrafterHtml( block.body_html ) } } />
        </>
    );
}
